"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnedItemText = exports.StyledColumnedItemLabel = exports.StyledItemText = exports.StyledItemLabel = exports.StyledItemElement = exports.StyledColumnedItemElement = exports.StyledColumnedItemContainer = exports.StyledItemContainer = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
exports.StyledItemContainer = Theme_1.styled.div `
  margin: 0 auto;
`;
exports.StyledColumnedItemContainer = Theme_1.styled.div `
  margin: 0 auto;
`;
exports.StyledColumnedItemElement = Theme_1.styled.div `
  height: 48px;
  display: flex;
  background: ${(props) => props.theme.white};
  :hover {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    background: ${(props) => props.theme.colors.gray[20]};
  }
  :active {
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    background: ${(props) => props.theme.colors.gray[30]};
  }
`;
exports.StyledItemElement = Theme_1.styled.div `
  width: 616px;
  height: 48px;
  display: flex;
  background: ${(props) => {
    if (props.isHovered && !props.isSelected) {
        return props.theme.colors.gray[20];
    }
    else if (props.isSelected) {
        return props.theme.colors.gray[30];
    }
    else {
        return props.theme.white;
    }
}};
  :hover {
    cursor: pointer;
    background: ${(props) => props.theme.colors.gray[20]};
  }
  :active {
    cursor: pointer;
    background: ${(props) => props.theme.colors.gray[30]};
  }
`;
exports.StyledItemLabel = Theme_1.styled.div `
  vertical-align: middle;
  width: ${(props) => props.width};
  height: ${(props) => props.height}px;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: ${(props) => props.paddingLeft}px;
  padding-right: ${(props) => props.paddingRight}px;
  flex: auto;
`;
exports.StyledItemText = Theme_1.styled.p `
  display: block;
  width: ${(props) => props.width};
  height: ${(props) => props.height}px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.theme.colors.gray[90]};
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  font-family: proxima-nova, arial, sans-serif;
`;
exports.StyledColumnedItemLabel = Theme_1.styled.div `
  vertical-align: middle;
  width: ${(props) => (props.width === 'auto' ? 'auto' : `${props.width}px`)};
  height: ${(props) => props.height}px;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: ${(props) => props.paddingLeft}px;
  padding-right: ${(props) => props.paddingRight}px;
  flex: auto;
`;
exports.StyledColumnedItemText = Theme_1.styled.p `
  display: block;
  width: ${(props) => (props.width === 'auto' ? 'auto' : `${props.width}px`)};
  height: ${(props) => props.height}px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.disabled ? props.theme.colors.gray[60] : props.theme.colors.gray[90]};
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  font-family: proxima-nova, arial, sans-serif;
`;
//# sourceMappingURL=DropdownItem.styles.js.map